import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    document.title = 'Terms of Service | ECORIDE Electric Bicycles';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-primary hover:text-primary-dark mb-8 transition-colors"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Home
        </button>

        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Terms of Service</h1>
          
          <div className="prose max-w-none text-gray-600">
            <p className="mb-4">Last updated: March 15, 2024</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Agreement to Terms</h2>
              <p className="mb-4">
                By accessing or using ECORIDE's website and services, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Use License</h2>
              <p className="mb-4">
                Permission is granted to temporarily access and use our website for personal, non-commercial purposes. This license does not include:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Modifying or copying materials</li>
                <li>Using materials for commercial purposes</li>
                <li>Attempting to reverse engineer any software</li>
                <li>Removing any copyright or proprietary notations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Product Information</h2>
              <p className="mb-4">
                We strive to provide accurate product information but do not warrant that product descriptions or other content is accurate, complete, reliable, current, or error-free.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Warranty and Returns</h2>
              <p className="mb-4">
                All ECORIDE electric bicycles come with a 5-year warranty against manufacturing defects. This warranty does not cover:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Normal wear and tear</li>
                <li>Damage from misuse or accidents</li>
                <li>Unauthorized modifications</li>
                <li>Improper maintenance</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Limitation of Liability</h2>
              <p className="mb-4">
                ECORIDE shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Governing Law</h2>
              <p className="mb-4">
                These terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Changes to Terms</h2>
              <p className="mb-4">
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Contact Information</h2>
              <p className="mb-4">
                Questions about the Terms of Service should be sent to:<br />
                Email: legal@ecoride.com<br />
                Phone: (555) 123-4567<br />
                Address: 123 Electric Avenue, San Francisco, CA 94103
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;